<div id="banner-autoinvest" class="swiper-background d-lg-flex align-items-center pt-5 pt-lg-0">
    <div class="container">
        <div class="row">
            <div class="col-sm-9 col-lg-7 d-flex flex-column justify-content-center">
                <div>
                    <p class="d-inline-block p-display-bold border-y-1 border-primary-900 primary-900 mb-2">AUTOINVEST
                        DE FACTORING</p>
                </div>
                <h1 class="h1-display primary-900 mb-3 mb-lg-2">Maximiza tus <span class="secondary-factoring-600">inversiones
                        sin esfuerzo</span></h1>
                <div class="d-lg-none">
                    <app-btn-link [linkId]="'btn-banner-autoinvest-factoring'" [linkTitle]="'Más información'" [linkType]="'routerLink'" [linkUrl]="'autoinvest'"></app-btn-link>
                </div>
                <p class="p-display primary-800 d-none d-lg-block">Herramienta revolucionaria de inversión
                    automática. Personaliza tus inversiones y rentabiliza al máximo tu capital disfrutando de las
                    ventajas del interés compuesto.
                </p>
                <div class="d-none d-lg-block mt-4">
                     <app-btn-link [linkId]="'btn-banner-autoinvest-factoring'" [linkTitle]="'Más información'" [linkType]="'routerLink'" [linkUrl]="'autoinvest'"></app-btn-link>
                </div>
            </div>
            <div class="col-12 d-lg-none img-container mx-auto mt-3">
                <img src="/assets/images/factoring/autoinvest/autoinvest-factoring.png" alt="imagen-bombilla"
                    class="img-fluid">
            </div>
            <!-- Desktop -->
            <div class="col-lg-5 d-none d-lg-block">
                <img src="/assets/images/factoring/autoinvest/autoinvest-factoring.png" alt="imagen-bombilla"
                    class="img-fluid mt-5">
            </div>
        </div>
    </div>
</div>